import {connect} from 'react-redux';
import FeaturedComparableMap from './FeaturedComparableMap';
import * as salesActions from '../actionCreators/comparableSales';
import * as listingsActions from '../actionCreators/comparableListings';
import * as rentalsActions from '../actionCreators/comparableRentals';

const comparableTypeToStore = {
  listings: {store: 'comparableListings', actions: listingsActions},
  sales: {store: 'comparableSales', actions: salesActions},
  rentals: {store: 'comparableRentals', actions: rentalsActions},
};

const mapStateToProps = (state, {propertyId, comparableType, markerLabel}) => {
  const storeName = comparableTypeToStore[comparableType].store;
  let comparableItems = state[storeName];
  const property = comparableItems.properties[propertyId];

  return {
    latLng: property?.latitude && property?.longitude && {lat: property?.latitude, lng: property?.longitude},
    targetLatLng: {lat: state.propertyDetail.latitude, lng: state.propertyDetail.longitude},
    center: property.mapCenter,
    zoom: property.mapZoom,
    markerLabel,
  };
};

const mapDispatchToProps = (dispatch, {propertyId, comparableType}) => {
  const actions = comparableTypeToStore[comparableType].actions;

  return {
    onMapZoomChange: (zoom) => dispatch(actions.updateForSession({
      propertyId,
      keyPath: 'mapZoom',
      value: zoom,
    }, true)),
    onMapCenterChange: (center) => dispatch(actions.updateForSession({
      propertyId,
      keyPath: 'mapCenter',
      value: center,
    }, true)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedComparableMap);
